<template>
  <div class="my_moduleShow_btn hideContent lineControl" @click="module_isShow" :title="title"><span class="el-icon-view"></span></div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'my_moduleShow_btn',
  data() {
    return {

    };
  },
  props:{
    title:{
      type:String,
      default:i18n.t('components_my_moduleshow_btn_index_2368')
    },
    radioName:{
      type:String,
      default:'logoTitleRadio'
    }
  },
  methods:{
    module_isShow() {
      this.templet.module_isShow(this.radioName)
    },
  }
};
</script>

<style lang="scss" scoped>
.my_moduleShow_btn:hover {
  background-color: #2e343B;
}
</style>



// WEBPACK FOOTER //
// src/components/my_moduleShow_btn/index.vue